import { SxProps, Theme } from '@mui/material/styles';
import colors from '../../../lib/styles/colors';
import { columnFlex } from '../../../lib/styles/commonStyles';

export const smallBoxSx = {
  ...columnFlex,
  width: '100%',
  padding: '16px',
};

export const titleBoxSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '24px',
};

// TODO: Use Typography variant from UI Kit after UI Kit is integrated
export const titleSx = {
  fontSize: '16px',
  fontWeight: 600,
};

export const heartIconButtonSx: SxProps<Theme> = (theme: Theme) => ({
  color: '#D68037',
  width: '32px',
  height: '32px',
});

export const heartBorder: SxProps<Theme> = (theme: Theme) => ({ color: theme.palette.action.active });

export const publishedIconSx: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.success.dark : theme.palette.success.light,
  backgroundColor: theme.palette.success?.subtle || '#DAEED8', // Fallback: 'subtle' not defined in dsLightTheme/dsDarkTheme
  borderRadius: theme.spacing(0.5), // 4px (0.5 × 8px spacing unit)
  padding: theme.spacing(0.75),
});

// Standard CSS values - no theme equivalents needed
export const publishedIconBoxSx: SxProps<Theme> = () => ({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'default',
});

export const descriptionSx = {
  fontSize: '16px',
  fontWeight: 400,
  height: '47px',
};

export const cardSx: SxProps<Theme> = (theme: Theme) => ({
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? colors.reportCardHover.dark : colors.reportCardHover.light,
  },
  boxShadow: '0px 0px 0px 1px rgba(12, 26, 75, 0.03), 0px 3px 4px 0px rgba(50, 50, 71, 0.05)',
  minHeight: '106px',
  borderRadius: '16px',
  flexDirection: 'row',
  display: 'flex',
  cursor: 'pointer',
});

export const cardAction: SxProps<Theme> = (theme: Theme) => ({
  '&.MuiButtonBase-root': {
    '&:focus': {
      border: `2px solid ${theme.palette.secondary.main}`,
      backgroundColor: theme.palette.mode === 'dark' ? colors.reportCardHover.dark : colors.reportCardHover.light,
    },
  },
  '&.Mui-focusVisible .MuiCardActionArea-focusHighlight': {
    opacity: 0,
  },
  '&.MuiCardActionArea-root:hover .MuiCardActionArea-focusHighlight': {
    opacity: 0,
  },
  width: '100%',
});

export const iconContainerSx = {
  display: 'flex',
  alignItems: 'center',
};

export const moreOptionsIconButtonSx = {
  ...heartIconButtonSx,
  ml: 1,
};

export const menuItemSx: SxProps<Theme> = (theme: Theme) => ({
  borderRadius: '8px',
  mx: 1,
  my: 0.2,
  px: 2,
  minHeight: 32,
  fontSize: '1rem',
  color: theme.palette.text.primary,
  '&:hover': {
    bgcolor: theme.palette.action.hover,
    fontWeight: 500,
  },
});

export const dividerSx = {
  width: '95%',
  margin: 'auto',
  borderColor: 'divider',
  marginTop: '0px',
  marginBottom: '0px',
};
